var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"portfolio"}},[_c('NavView'),_c('FrontView',{attrs:{"id":"front"}}),_c('SkillsView'),_c('ProjectView',{attrs:{"id":"projects"}}),_c('ContactView',{attrs:{"id":"contactme"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }